<template>
  <div class="emailConnections">
    <div class="top_center">
      <div class="emailConnection">
        <div class="addressee">收件人</div>
        <div class="addressee">
          <el-input v-model="name" disabled></el-input>
        </div>
        <div class="addressee">主题</div>
        <div class="addressee_input">
          <el-input v-model="subject"></el-input>
        </div>
        <div class="templates">
          <div class="cursor templates_top">
            <el-button
              type="primary"
              icon="el-icon-setting"
              @click="openTemplateM"
              >管理模板</el-button
            >
            <el-dropdown size="small" trigger="click">
              <div class="templates_selice ru5">
                选择模板
                <i class="el-icon-caret-bottom co6e"></i>
              </div>
              <el-dropdown-menu :visible-arrow="false" slot="dropdown">
                <div class="templates_list ru5">
                  <div v-if="templatesList.length">
                    <div
                      class="lists center sz16 cursor"
                      v-for="(item, index) in templatesList"
                      :key="index"
                      @click="selicetem(item)"
                    >
                      {{ item.name }}
                    </div>
                  </div>
                  <div v-else class="lists center sz16 cursor">暂无模板</div>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="addressee">正文</div>
        <div style="border: 1px solid #ccc">
          <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
          />
          <Editor
            style="
              min-height: 450px;
              width: 100%;
              overflow-y: hidden;
              background: #fff;
            "
            v-model="html"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="onCreated"
            @onChange="onChange"
          />
        </div>
        <div class="statement flex">
          <p class="statement_text">
            Tips：平台接受处理违规信息的联系方式为：support@foshobrands.com
          </p>
          <p
            class="statement_img center ru50 co6e cursor"
            @mouseenter="mouseover"
            @mouseleave="mouseout"
          >
            ?
          </p>
          <div
            class="statement_pre"
            v-show="statementStuts == 1"
            @mouseenter="mouseover"
            @mouseleave="mouseout"
          >
            <pre>
平台声明：平台尽最大努力采取技术措施和组织措施，在提供给客户的信息
  或内容中，过滤或删除任、何违反中华人民共和国法律法规或有损害中华人
  民共和国国家安全、政治安全或丑化、侮辱中华人民共和国国家尊严或有违
  中华人民共和国公序良俗的信息或内容（“违规内容”）。如果客户在使用
  平台的服务过程中发现有违规内容的，请客户立即停止浏览、使用或传播该  
  信息，并立即向平台报告。否则，由此带来的一切责任由客户自己承担。
  请勿使用其他平台进行联系，若脱离本平台产生问题，后果自负。
        </pre
            >
          </div>
          <div class="submit_top">
            <div class="submit center ba6e coff ru5">
              <div class="center ba6e coff ru5 sz14" @click="submit">发送</div>
            </div>
          </div>
        </div>
        <div class="drawer_center">
          <el-drawer
            title=""
            :visible.sync="drawer"
            direction="rtl"
            :size="widthSize"
            :before-close="handleCloses"
            :modal="false"
          >
            <div class="drawer_top">
              <!-- <div class="drawer_title flex"> -->
              <div class="drawer_img">
                <img
                  v-if="zkstyts == 1"
                  class="cursor"
                  src="@/assets/img/emil/zk.png"
                  alt=""
                  @click="widthclice(1)"
                />
                <img
                  v-if="zkstyts == 2"
                  class="cursor"
                  src="@/assets/img/emil/sq.png"
                  alt=""
                  @click="widthclice(2)"
                />
              </div>
              <!-- </div> -->
            </div>
          </el-drawer>
        </div>
        <!-- <el-drawer title="" :visible.sync="drawer" width="50%" :with-header="false" :modal="false" :show-close="false">
          <div></div>
        </el-drawer> -->
      </div>
      <el-dialog
        title=""
        :visible.sync="dialogVisible"
        width="30%"
        top="15%"
        :before-close="handleClose"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        center
      >
        <div class="content flex">
          <div class="content_img">
            <img src="@/assets/img/emil/gg.png" alt="" />
          </div>
          <div>
            <p class="content_p1">已发送</p>
            <p class="content_p2">此邮件发送成功，并已保存到“发件箱”文件夹</p>
            <!-- <p class="content_p3">P**.hu***@foshobrands.com</p> -->
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <div class="flex butt">
            <!-- <div class="butt_one center coff ba6e cursor" @click="details">查看详情</div> -->
            <div
              class="butt_two center coff ba6e cursor"
              type="primary"
              @click="gooubox"
            >
              返回发件箱
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
    <email ref="emailTemplate" @templateBack="templateBack"></email>
  </div>
</template>
<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue"; // 引入子组件
import {
  EMAILTEMPLATE,
  TEMPLATES,
  SENDEMAIL,
  QUERY,
  QUERYMAINPERMIT,
} from "../../api/emial"; // 引入接口名称
import { DomEditor } from "@wangeditor/editor";
export default {
  // 组件实例,注册子组件
  components: {
    Editor,
    Toolbar,
    email: () => import("@/components/EmailTemplate.vue"),
  },
  // dom实例 dom数据
  data() {
    return {
      editor: null,
      html: "",
      toolbarConfig: {},
      editorConfig: { placeholder: "请输入内容..." },
      mode: "default", // or 'simple',
      texts: "",
      templatesList: [], // 模板列表
      statementStuts: 0, // 平台声明 0不显示 1显示
      subject: "", // 主題
      name: "",
      allianceCode: [],
      dialogVisible: false,
      drawer: false,
      widthSize: "45%",
      zkstyts: 1,
      queryMainPermitList: [],
    };
  },
  // 生命周期函数 页面加载完成触发
  mounted() {
    this.querylsi();
    this.name = this.$route.query.name;
    let str = this.$route.query.allianceCode;
    let arr = str.split(",");
    this.allianceCode = arr;
    this.templateshtml();
    this.queryMainPermit();
    // this.name = localStorage.getItem('names')
    // 模拟 ajax 请求，异步渲染编辑器
  },
  // 事件方法
  methods: {
    queryMainPermit() {
      QUERYMAINPERMIT().then((res) => {
        this.queryMainPermitList = res.data.body;
      });
    },
    // 获取登录信息
    querylsi() {
      QUERY().then((res) => {
        if (res.data.code == "nolog") {
          this.$router.push("./");
        } else if (res.data.code == "forceout") {
          // this.$message({
          //   message: '账号在其他地方登录,您被迫下线',
          //   type: 'warning'
          // });
          localStorage.removeItem("token");
        }
      });
    },
    onCreated(editor) {
      this.editor = Object.seal(editor);
      this.toolbarConfig = {
        excludeKeys: [
          "insertVideo",
          "uploadVideo",
          "group-video",
          "group-image",
          "insertLink",
          "fullScreen",
          "codeBlock",
        ],
      };
    },
    onChange(editor) {
      const toolbar = DomEditor.getToolbar(editor);
    },
    // 获取邮件模板
    templateshtml() {
      EMAILTEMPLATE({
        currentPage: 1,
        size: 100,
      }).then((res) => {
        this.templatesList = res.data.body.records;
      });
    },
    // 发送邮件
    submit() {
      if (!this.subject) {
        this.$message({
          message: "请输入邮件主题",
          type: "warning",
        });
        return;
      }
      if (!this.editor.getText()) {
        this.$message({
          message: "请输入邮件内容",
          type: "warning",
        });
        return;
      }
      let str = this.$route.query.allianceCode;
      let arr = str.split(",");
      let data = {
        allianceCodes: arr,
        subject: this.subject,
        contentText: this.editor.getText(),
        contentHtml: this.html,
      };
      SENDEMAIL(data).then((res) => {
        if (res.data.code == "error") {
          this.$message({
            message: res.data.msg,
            type: "warning",
          });
        } else {
          localStorage.setItem("isemitco", "发件箱");
          localStorage.setItem("isSelect", "邮箱建联");
          let routeUrl = this.$router.resolve({ path: "outbox" });
          window.open(routeUrl.href, "_self");
          this.$message({
            message: "发送成功",
            type: "success",
          });
        }
      });
    },
    // 选择模板
    selicetem(e) {
      this.html = e.content;
    },
    // vue hover事件鼠标移入触发
    mouseover() {
      this.statementStuts = 1;
    },
    // vue hover事件鼠标移出触发
    mouseout() {
      this.statementStuts = 2;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 关闭抽屉
    handleCloses() {
      this.drawer = false;
    },
    // 查看详情
    details() {
      this.dialogVisible = false;
      this.drawer = true;
    },
    // 返回发件箱
    gooubox() {
      this.dialogVisible = false;
      this.queryMainPermitList.map((item) => {
        if (item.permits) {
          item.permits.map((item) => {
            if (item.title == "发件箱") {
              if (item.isLock == 0) {
                localStorage.setItem("validParam", item.validParam);
                localStorage.setItem("isemitco", "发件箱");
                localStorage.setItem("isSelect", "邮箱建联");
                let routeUrl = this.$router.resolve({ path: "outbox" });
                // this.$router.push({
                //   path: 'outbox'
                // })
                window.open(routeUrl.href, "_self");
              } else {
                this.$bus.$emit("showNopermiss", true);
              }
            }
          });
        }
      });
    },
    // 展开收起
    widthclice(e) {
      if (e == 1) {
        this.widthSize = "85.5%";
        this.zkstyts = 2;
      } else {
        this.widthSize = "45%";
        this.zkstyts = 1;
      }
    },
    openTemplateM() {
      this.$refs.emailTemplate.init();
    },
    templateBack() {
      this.templateshtml();
    },
  },

  // 生命周期函数  组件销毁
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
@media screen and (min-width: 1000px) and (max-width: 2000px) {
  .top_center {
    width: 1600px;
    margin: 0 auto;
  }
}
@media screen and (min-width: 2000px) and (max-width: 3000px) {
  .top_center {
    width: 1920px;
    margin: 0 auto;
  }
}
.emailConnections {
  padding-top: 112px;
  // padding-left: 10%;
  box-sizing: border-box;
  background: #fafafd;
}
//  css样式表
.emailConnection {
  padding: 30px 0;
  width: 98%;
  margin: 0 auto;
  padding-bottom: 150px;
  .addressee {
    margin-bottom: 15px;
  }
  .addressee_input {
    margin-bottom: 80px;
  }
  .templates {
    width: 100%;
    height: 40px;
    .templates_top {
      float: right;
      display: flex;
      gap: 20px;
    }
    .templates_selice {
      width: 206px;
      height: 40px;
      line-height: 40px;
      padding-left: 22px;
      box-sizing: border-box;
      border: 1px solid #d8dee8;
      float: right;
      position: relative;
      i {
        font-size: 26px;
        position: absolute;
        top: 50%;
        right: 20px;
        margin-top: -13px;
      }
    }
    .templates_list {
      width: 206px;
      padding: 24px 0;
    }
  }

  .statement {
    width: 100%;
    height: 160px;
    margin-top: 12px;
    position: relative;
    .statement_img {
      width: 23px;
      height: 23px;
      line-height: 23px;
      border: 1px solid #be3c6e;
      margin-left: 10px;
      margin-right: 5px;
    }
    .statement_pre {
      padding-left: 10px;
      background: #000;
      color: #fff;
      padding-bottom: 10px;
      pre {
        margin-top: 5px;
      }
    }
    .submit_top {
      width: 97px;
      height: 50px;
      position: absolute;
      right: 0;
      .submit {
        width: 97px;
        height: 39px;
        line-height: 39px;
      }
    }
  }
  .drawer_top {
    padding-left: 37px;
    .drawer_img {
      height: 28px;
      position: absolute;
      top: 20px;
      right: 76px;
      img {
        height: 100%;
      }
    }
  }
}
</style>
<style lang="less">
// element 组件样式表
.el-popper[x-placement^="bottom"] {
  width: 206px;
}
.el-dialog {
  border-radius: 5px !important;
}
.el-icon-close:before {
  font-size: 28px;
  // color: #be3c6e;
}
.w-e-scroll {
  min-height: 500px;
}
.el-drawer__wrapper {
  top: 70px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  margin: 0;
}
.drawer_center {
  .el-icon-close:before {
    color: #232323;
  }
}
.w-e-hover-bar {
  display: none;
}
</style>
